import {Button, type ButtonProps} from '@primer/react'
import {useCallback, useState} from 'react'
import {StarFillIcon, StarIcon} from '@primer/octicons-react'
import {reactFetch} from '@github-ui/verified-fetch'

interface StarButtonProps extends Omit<ButtonProps, 'onClick' | 'leadingIcon' | 'children'> {
  path: string
  starred: boolean
  onToggleCallback?: (starred: boolean) => void
  signInPath?: string
}

export function StarButton({path, starred, onToggleCallback, signInPath, ...buttonProps}: StarButtonProps) {
  const [currentlyStarred, setCurrentlyStarred] = useState(starred)

  const onToggle = useCallback(async () => {
    const actionPath = `${path}/${currentlyStarred ? 'unstar' : 'star'}`
    setCurrentlyStarred(!currentlyStarred)
    const res = await reactFetch(actionPath, {method: 'POST'})
    if (!res.ok) {
      // Starring failed, so revert back to the previous state
      setCurrentlyStarred(currentlyStarred)
      return
    }
    onToggleCallback?.(!currentlyStarred)
  }, [currentlyStarred, onToggleCallback, path])

  return signInPath ? (
    <Button size="small" leadingVisual={StarIcon} {...buttonProps} as="a" href={signInPath}>
      {currentlyStarred ? 'Unstar' : 'Star'}
    </Button>
  ) : (
    <Button size="small" onClick={onToggle} leadingVisual={currentlyStarred ? StarFillIcon : StarIcon} {...buttonProps}>
      {currentlyStarred ? 'Unstar' : 'Star'}
    </Button>
  )
}
